import { Form, useSubmit, useParams, redirect, Params, useNavigate } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import * as React from "react";
import { RootStore } from "../../../stores/root-store";
import { Constants } from "../../../globals/constants";

export async function action(params: Params, rootStore: RootStore) {
    if (params.compensationId !== undefined) {
        const compensationId = parseInt(params.compensationId) || 0;
        const rootStoreSession = rootStore.session;
        const compensation = await rootStoreSession.compensationStore.delete(compensationId);
        return redirect(`/projekte/${Constants.projectCategoryUsage}/${compensation.usageProjectId}`);
    }

    throw new Response("", {
        status: 404,
        statusText: "Kompensation wurde nicht gefunden",
    });
}

export default function CompensationDelete(): JSX.Element {
    const submit = useSubmit();
    const navigate = useNavigate();
    const { compensationId } = useParams();

    return (
        <Modal
            size="mini"
            open={true}
        >
            <Modal.Content>
                <Form method="delete"
                      id="deleteCompensationForm">
                    Kompensation wirklich löschen?
                    <input type="hidden" name="fffCompensationId" value={compensationId}/>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button type="button" onClick={() => navigate(-1)}>Abbrechen</Button>
                <Button onClick={() => submit(document.getElementById("deleteCompensationForm") as HTMLFormElement)}>
                    Löschen
                </Button>
            </Modal.Actions>
        </Modal>
    );
}